import { Text, TextInput } from "@mantine/core";
import { useFormContext } from "react-hook-form";
import { useIsOnline } from "src/hooks";

import { StyledYachtSetUpItem } from "../YachtSetUp.styled";

const PositioningEquipment = () => {
  const { register } = useFormContext();
  const isOnline = useIsOnline();
  return (
    <StyledYachtSetUpItem mx="auto" mb="xl">
      <Text size="sm">DP Equipment:</Text>
      <TextInput
        style={{ flex: 1 }}
        {...register("equip", { disabled: !isOnline })}
      />
      <Text size="sm">DP Equipement Class:</Text>
      <TextInput
        style={{ flex: 1 }}
        {...register("equipclass", { disabled: !isOnline })}
      />
    </StyledYachtSetUpItem>
  );
};

export default PositioningEquipment;
